var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-pwd-reset" }, [
    _c(
      "form",
      {
        ref: "loginForm",
        attrs: { id: "login-form-" + _vm._uid, method: "post" },
      },
      [
        _c("div", { class: { "modal-body": _vm.modalElement } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  attrs: { "data-validate": "mail" },
                },
                [
                  _c("label", { attrs: { for: "email" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginEmail")) + "*"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.username,
                        expression: "username",
                      },
                    ],
                    attrs: {
                      "data-testing": "email-login",
                      type: "email",
                      name: "email",
                      autocomplete: "email",
                      placeholder: _vm.multiLanguage.LoginEmailPlaceholder,
                      id: "email" + _vm._uid,
                      "data-autofocus": "",
                    },
                    domProps: { value: _vm.username },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.username = $event.target.value
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "error-msg" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginEnterConfirmEmail")
                    ) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit position-relative",
                  class: { "no-bottom": _vm.modalElement },
                  attrs: { "data-validate": "text" },
                },
                [
                  _c("label", { attrs: { for: "password" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginPassword")) +
                        "*"
                    ),
                  ]),
                  _vm._v(" "),
                  (_vm.typePassword ? "password" : "text") === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        attrs: {
                          "data-testing": "password-login",
                          name: "password",
                          autocomplete: "current-password",
                          placeholder:
                            _vm.multiLanguage.LoginPasswordPlaceholder,
                          id: "password" + _vm._uid,
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password)
                            ? _vm._i(_vm.password, null) > -1
                            : _vm.password,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.password = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password = $$c
                            }
                          },
                        },
                      })
                    : (_vm.typePassword ? "password" : "text") === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        attrs: {
                          "data-testing": "password-login",
                          name: "password",
                          autocomplete: "current-password",
                          placeholder:
                            _vm.multiLanguage.LoginPasswordPlaceholder,
                          id: "password" + _vm._uid,
                          type: "radio",
                        },
                        domProps: { checked: _vm._q(_vm.password, null) },
                        on: {
                          change: function ($event) {
                            _vm.password = null
                          },
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        attrs: {
                          "data-testing": "password-login",
                          name: "password",
                          autocomplete: "current-password",
                          placeholder:
                            _vm.multiLanguage.LoginPasswordPlaceholder,
                          id: "password" + _vm._uid,
                          type: _vm.typePassword ? "password" : "text",
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.password = $event.target.value
                          },
                        },
                      }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "position-absolute password-visible cursor-pointer",
                      staticStyle: { top: "2rem", right: "1rem" },
                      on: { click: _vm.toggleTypePassword },
                    },
                    [
                      !_vm.typePassword
                        ? _c(
                            "svg",
                            {
                              attrs: {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z",
                                  stroke: "#121926",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z",
                                  stroke: "#121926",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.typePassword
                        ? _c(
                            "svg",
                            {
                              attrs: {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213",
                                  stroke: "#121926",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "error-msg" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginEmptyPassword")
                    ) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-right mb-3" }, [
          _c(
            "a",
            {
              staticClass: "text-appearance",
              attrs: { href: "javascript:void(0)", rel: "nofollow" },
              on: { click: _vm.showResetPwdView },
            },
            [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.loginForgotPassword")) +
                  "?"
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-appearance btn-medium w-100",
            attrs: { "data-testing": "submit-login", disabled: _vm.isDisabled },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.validateLogin.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
                    stroke: "white",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$translate("Ceres::Template.login")) +
                  "\n      "
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }